import { RootState } from '../../app/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit'


export enum MessageBoxAction{
    GoBack = 0,
    DeleteAttendee = 1,
    GoToCurrentsPartyEvents = 2,
    GoHome = 3
}
export interface MessageBoxState {
    message : string | null
    messageBoxAction : MessageBoxAction
}

const initialState: MessageBoxState = {
    message : null,
    messageBoxAction : MessageBoxAction.GoBack
}

export const messageBoxSlice = createSlice({
    name: 'messageBox',
    initialState: initialState,
    reducers: {
        setMessage: (state, action: PayloadAction<string>) => {
            state.message = action.payload
        },
        setMessageBoxAction : (state, action: PayloadAction<MessageBoxAction>) => {
            state.messageBoxAction = action.payload
        }
    }

})

export const {setMessage , setMessageBoxAction} = messageBoxSlice.actions
export const selectMessage = (state:RootState) => state.messageBox.message
export const selectMessageBoxAction = (state:RootState) => state.messageBox.messageBoxAction
export default messageBoxSlice.reducer